import React, { useState, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
function Login() {
    const navigate = useNavigate();
    const { login } = useContext(AuthContext);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    // console.log(role)
    const loginSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission

        try {
            const response = await axios.post('auth/login', { username, password });

            if (response.data.status === 1) {
                // Store user token and role
                localStorage.setItem('token', response.data.token);
                sessionStorage.setItem('username', response.data.username);
                sessionStorage.setItem('role', response.data.role);

                let staffDetails = {
                    staff_id: null,
                    staff_name: response.data.username,
                    phone_no: null,
                    role: response.data.role
                };

                // If the user is NOT a super_admin, fetch staff details
                if (response.data.role !== "super_admin") {
                    try {
                        const staffResponse = await axios.get(`master/users/${username}`);
                        if (staffResponse.data.success !== 0) {
                            staffDetails = {
                                staff_id: staffResponse.data.staff_id,
                                staff_name: staffResponse.data.staff_name,
                                phone_no: staffResponse.data.phone_no,
                                role: staffResponse.data.role
                            };

                            sessionStorage.setItem('staff_id', staffDetails.staff_id);
                            sessionStorage.setItem('staff_name', staffDetails.staff_name);
                            sessionStorage.setItem('phone_no', staffDetails.phone_no);
                        }
                    } catch (staffError) {
                        Swal.fire({
                            icon: "error",
                            text: "No staff record found, proceeding without staff details.",
                            type: "success",
                            timer: 4000,
                            showConfirmButton: false,
                        });
                        console.warn("No staff record found, proceeding without staff details.");
                    }
                }

                // Login user with available details
                login(username, password, staffDetails.staff_id, staffDetails.staff_name, staffDetails.phone_no, staffDetails.role);
                Swal.fire({
                    icon: "success",
                    text: "Welcome Back!",
                    type: "success",
                    timer: 2000,
                    showConfirmButton: false,
                });
                navigate('/order'); // Navigate to order page

            } else {
                Swal.fire({
                    icon: "error",
                    text: response.data.message,
                    type: "success",
                    timer: 2000,
                    showConfirmButton: false,
                });
                setErrorMessage(response.data.message);
            }
        } catch (error) {
            // Swal.fire({
            //     icon: "error",
            //     text: "Incorrect Username or password",
            //     type: "success",
            //     timer: 2000,
            //     showConfirmButton: false,
            // });
            console.error("Error logging in:", error);
            setErrorMessage("Incorrect Username or password");
        }
    };

    return (
        <>
            <div className="flex flex-col items-center justify-center h-screen loginbg bg-cover bg-center">

                <div className="-mt-24 flex flex-col items-center">

                    <header className="text-center mb-4">
                        <h1 className="text-4xl sm:text-4xl font-bold text-white">
                            Best Fashions
                        </h1>
                    </header>

                    <div className="login-bg-card w-full max-w-xs bg-white rounded-xl p-6 shadow-[0_0_40px_rgba(220,38,38,0.35)]">
                        <header className="text-center pb-3">
                            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-sidebar-color">
                                Login
                            </h1>
                        </header>

                        <form onSubmit={loginSubmit}>
                            <div>
                                <label className="block mb-2 text-sidebar-color" htmlFor="username">Username</label>
                                <input
                                    className="w-full p-2 mb-2 text-sidebar-color border-b-2 border-sidebar-color outline-none focus:bg-gray-300"
                                    type="text"
                                    name="username"
                                    required
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </div>
                            <div className="relative">
                                <label className="block mb-2 text-sidebar-color" htmlFor="password">Password</label>
                                <input
                                    className="w-full p-2 mb-6 text-sidebar-color border-b-2 border-sidebar-color outline-none focus:bg-gray-300 pr-10"
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    required
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <span
                                    className="absolute right-3 top-10 cursor-pointer text-sidebar-color"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                            {errorMessage && (
                                <div className="text-red-500 text-sm mb-4">{errorMessage}</div>
                            )}
                            <div>
                                <button
                                    className="before:ease relative h-12 w-full font-bold py-2 px-4 mb-6 overflow-hidden border border-sidebar-color bg-sidebar-color text-white shadow-2xl transition-all before:absolute before:right-0 before:top-0 before:h-12 before:w-6 before:translate-x-12 before:rotate-6 before:bg-white before:opacity-10 before:duration-700 hover:shadow-sidebar-color hover:before:-translate-x-80"
                                    type="submit"
                                >
                                    <span relative="relative z-10">Submit</span>
                                </button>
                            </div>
                        </form>
                        <div className="flex justify-center items-center whitespace-nowrap mt-4">
                            <p className="text-sm md:text-base">
                                Designed By{" "}
                                <a
                                    href="https://dce.technology/"
                                    target="blank"
                                    className="inline text-red-600 hover:underline"
                                >
                                    DCE Technology
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
                </div>
            </>
            );
};

            export default Login;
